export default "__VITE_ASSET__seXhdZhB__"